import * as React from 'react';

// Assets
const StartSVG = require('../../assets/illustrations/start.svg') as string;

// Components
import Button from '../../components/Button';
import Container from '../../components/Container';
import StatusCard from '../../components/StatusCard';

// Component
interface IProps {
  openNetworkManager: () => void;
}
class AppIntro extends React.Component<IProps> {
  render() {
    return (
      <Container size={'md'} padded={true}>
        <StatusCard
          icon={StartSVG}
          headline={'Welcome to Spotter!'}
          subheading={'Join or create a network to get started'}
          actions={
            <div>
              <Button
                raised={true}
                color={'primary'}
                style={{ margin: '0 8px' }}
                onClick={this.props.openNetworkManager}
              >
                Manage networks
              </Button>
            </div>
          }
        />
      </Container>
    );
  }
}

export default AppIntro;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppIntro/AppIntro.tsx